import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import {
    ProductPromotionModel,
    ProductPromotionsState,
} from "@preferredMedical/Store/Pages/ProductPromotions/ProductPromotionsState";
import { Draft } from "immer";

const initialState: ProductPromotionsState = {
    productPromotions: {},
};

const reducer = {
    "Custom/Pages/ProductPromotions/SetProductPromotions": (
        draft: Draft<ProductPromotionsState>,
        action: { productPromotions: { [key: string]: ProductPromotionModel[] } },
    ) => {
        draft.productPromotions = action.productPromotions;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
